module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pt-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pa-0 mt-1",
    attrs: {
      "append-icon": "search",
      "placeholder": _vm.$vuetify.breakpoint.smAndUp ? 'Search by phone no, email, etc.' : 'Search',
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-download-as', {
    attrs: {
      "headers": _vm.notifyLoghead,
      "items": _vm.notifyLogs,
      "landscape": true,
      "fontsize": 8,
      "cellpadding": 1,
      "title": "Notification logs"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.notifyLogHeadersm : _vm.notifyLogHeader,
      "items": _vm.notifyLogs,
      "rows-per-page-items": [10, 25, 50, {
        'text': '$vuetify.dataIterator.rowsPerPageAll',
        'value': -1
      }],
      "pagination": _vm.paginationRowsPerPage,
      "disable-initial-sort": "",
      "search": _vm.search
    },
    on: {
      "update:pagination": function($event) {
        _vm.paginationRowsPerPage = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.notify_time))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.template))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.notify_type))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.contact_email || 'NA'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.contact_phone || 'NA'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.cust_name || 'NA'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.notify_result))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.msg_title || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.msg_text))]) : _vm._e()])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-btn', {
    style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:65px; left:25px;' : 'bottom:15px; left:320px;')),
    attrs: {
      "dark": "",
      "fab": "",
      "fixed": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prepareFilter.apply(null, arguments)
      }
    }
  }, [_c('v-badge', {
    attrs: {
      "overlap": "",
      "color": "info"
    },
    scopedSlots: _vm._u([(_vm.enabledFilter) ? {
      key: "badge",
      fn: function() {
        return [_c('v-icon', {
          staticClass: "caption"
        }, [_vm._v("done")])]
      },
      proxy: true
    } : null], null, true)
  }, [_vm._v(" "), _c('v-icon', {
    staticClass: "pa-2"
  }, [_vm._v("filter_list")])], 1)], 1)], 1), _vm._v(" "), _c('v-bottom-sheet', {
    staticClass: "caption",
    attrs: {
      "inset": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showFilter),
      callback: function($$v) {
        _vm.showFilter = $$v
      },
      expression: "showFilter"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "caption primary--text"
  }, [_vm._v("Filter by attributes")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Context",
      "hide-details": "",
      "maxlength": "30"
    },
    model: {
      value: (_vm.filter.template),
      callback: function($$v) {
        _vm.$set(_vm.filter, "template", $$v)
      },
      expression: "filter.template"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": ['Email', 'SMS', 'Push'],
      "label": "Type",
      "hide-details": "",
      "small-chips": "",
      "clearable": "",
      "dense": "",
      "multiple": ""
    },
    model: {
      value: (_vm.filter.notify_type_list),
      callback: function($$v) {
        _vm.$set(_vm.filter, "notify_type_list", $$v)
      },
      expression: "filter.notify_type_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "User",
      "items": _vm.users,
      "item-text": "user_name",
      "item-value": "user_id",
      "hide-details": "",
      "small-chips": "",
      "clearable": "",
      "dense": "",
      "multiple": ""
    },
    model: {
      value: (_vm.filter.user_list),
      callback: function($$v) {
        _vm.$set(_vm.filter, "user_list", $$v)
      },
      expression: "filter.user_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Mobile no.",
      "hide-details": "",
      "maxlength": "15"
    },
    model: {
      value: (_vm.filter.contact_phone),
      callback: function($$v) {
        _vm.$set(_vm.filter, "contact_phone", $$v)
      },
      expression: "filter.contact_phone"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-mail",
      "hide-details": "",
      "maxlength": "50"
    },
    model: {
      value: (_vm.filter.contact_email),
      callback: function($$v) {
        _vm.$set(_vm.filter, "contact_email", $$v)
      },
      expression: "filter.contact_email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": ['Success', 'Fail'],
      "label": "Status",
      "hide-details": "",
      "small-chips": "",
      "clearable": "",
      "dense": "",
      "multiple": ""
    },
    model: {
      value: (_vm.filter.notify_result_list),
      callback: function($$v) {
        _vm.$set(_vm.filter, "notify_result_list", $$v)
      },
      expression: "filter.notify_result_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "caption primary--text pt-3"
  }, [_vm._v("Filter by date")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgFromDate",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.filter.from_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.filter, "from_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.filter, "from_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgFromDate),
      callback: function($$v) {
        _vm.dlgFromDate = $$v
      },
      expression: "dlgFromDate"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "From date",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.filter.from_dt),
      callback: function($$v) {
        _vm.$set(_vm.filter, "from_dt", $$v)
      },
      expression: "filter.from_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.filter.from_dt),
      callback: function($$v) {
        _vm.$set(_vm.filter, "from_dt", $$v)
      },
      expression: "filter.from_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgFromDate = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgFromDate.save(_vm.filter.from_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgToDate",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.filter.to_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.filter, "to_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.filter, "to_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgToDate),
      callback: function($$v) {
        _vm.dlgToDate = $$v
      },
      expression: "dlgToDate"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "To date",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.filter.to_dt),
      callback: function($$v) {
        _vm.$set(_vm.filter, "to_dt", $$v)
      },
      expression: "filter.to_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.filter.to_dt),
      callback: function($$v) {
        _vm.$set(_vm.filter, "to_dt", $$v)
      },
      expression: "filter.to_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgToDate = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgToDate.save(_vm.filter.to_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showFilter = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Clear all")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": _vm.applyFilter
    }
  }, [_vm._v("Apply")])], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 2000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])]), _vm._v(" "), (_vm.load) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "20%",
      "left": "50%"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f8e063a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notifylogs.vue
// module id = 904
// module chunks = 21